(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["compare-product-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const compareProductSwitchBtn = document.querySelectorAll('.compare-product-switch-btn');
  compareProductSwitchBtn.forEach(btn => {
    btn.addEventListener('click', function() {
      const productIndex = this.getAttribute('data-product-index');
      showProductCollection(this.getAttribute('data-collection-index'), productIndex);
      // compareProductSwitchBtn.forEach(btn => btn.classList.remove('active'));
      // this.classList.add('active');
    });
  });

  const navItemLinks = document.querySelectorAll('.nav-item:not(.compare-button-item)');
  navItemLinks.forEach(link => {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      navItemLinks.forEach((item) => {
        item.querySelector('.nav-link').classList.remove('active');
        item.classList.remove('active');
      });
      const navLink = this.querySelector('.nav-link');
      navLink.classList.add('active');
      this.classList.add('active');
      showProductCollection(navLink.getAttribute('data-collection-index'), '1');
    });
  });
});
function showProductCollection(collectionIndex, productIndex) {
  const productForms = document.querySelectorAll('.compare-product-form');
  productForms.forEach(form => {
    console.log(form.getAttribute('data-collection-index'), collectionIndex);
    if (form.getAttribute('data-collection-index') === collectionIndex && form.getAttribute('data-product-index') === productIndex) {
      form.classList.remove('hidden');
    } else {
      form.classList.add('hidden');
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
